import React from 'react';
import { useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { findMedia } from '@interness/web-core/src/components/_helpers';
import { jsx as ___EmotionJSX } from "@emotion/react";
const HeaderMedia = _ref => {
  let {
    id
  } = _ref;
  const data = useStaticQuery(query);
  const media = findMedia(data.headerImages.images, id);
  if (media) {
    return ___EmotionJSX(Img, {
      fluid: media.childImageSharp.fluid,
      loading: "eager",
      critical: true,
      fadeIn: false
    });
  } else {
    return null;
  }
};
export default HeaderMedia;
const query = "1818142893";